import { SqliteStorage } from '@/db/sqlite/sqlite'

export const dbSqlite = new SqliteStorage()
